/** Max data rows per server CSV export (orders list rows / revenue order rows). Meta/header rows do not count toward this cap. */
export const CSV_EXPORT_MAX_ROWS = 25_000
